export const NEXT_AFTER_REGISTRATION = 'nextAfterRegistration';
export const ONBOARDING_MODE = 'onboardingMode';
